const ActivityCreationService = {
  isResourceURLValid(url: string): boolean {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    } catch {
      return false;
    }
  },
  isVideoURLValid(url: string): string | false {
    try {
      const parsedUrl = new URL(url);
      const hostname = parsedUrl.hostname.replace('www.', '');
      let videoId = '';

      if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
        if (parsedUrl.pathname === '/watch') {
          videoId = parsedUrl.searchParams.get('v') || '';
        } else if (parsedUrl.pathname.startsWith('/live/')) {
          videoId = parsedUrl.pathname.split('/')[2] || '';
        } else if (parsedUrl.pathname.startsWith('/embed/')) {
          videoId = parsedUrl.pathname.split('/')[2] || '';
        } else if (parsedUrl.pathname.startsWith('/shorts/')) {
          videoId = parsedUrl.pathname.split('/')[2] || '';
        }
      } else if (hostname === 'youtu.be') {
        videoId = parsedUrl.pathname.substring(1);
      }

      return /^[a-zA-Z0-9_-]{11}$/.test(videoId) ? videoId : false;
    } catch {
      return false;
    }
  },
  reformatVideoURL(url: string): string {
    try {
      const videoID = this.isVideoURLValid(url);
      if (!videoID) throw Error('Invalid URL');

      const newURL = `https://www.youtube.com/watch?v=${videoID}`;
      return newURL;
    } catch {
      console.error('Failed to reformat video url');
      return url;
    }
  },
};

export default ActivityCreationService;
